import moment from 'moment'
import { repeatStringForService } from '../../helpers'
import { ITown, IServiceInfo } from '../../models'
import { BaseHttpService } from './base'

class ServicesInfoService extends BaseHttpService {
  public getServicesByServiceId = async (
    serviceInfoId: number
  ): Promise<IServiceInfo[]> => {
    return this.get(`services/${serviceInfoId}`)
  }

  public getDestinationBusStops = async (
    serviceInfoId: number,
    stopId: number
  ): Promise<ITown[]> => {
    return this.get(`services/${serviceInfoId}/stops-from/${stopId}?mergedStops=true`)
  }

  public getAvailabilities = async (
    serviceInfoId: number,
    originStopId: number,
    destinationStopId: number,
    exitSeats: number,
    exitPrmSeats: number,
    date: Date,
    specificDate: boolean,
    data?: any
  ): Promise<IServiceInfo[]> => {
    const exitString = repeatStringForService(
      '',
      destinationStopId,
      exitSeats + exitPrmSeats
    )

    let exitPrmSeatsString = ''
    if (exitPrmSeats > 0) {
      exitPrmSeatsString = repeatStringForService(
        '&prm-exit-stops=',
        destinationStopId,
        exitPrmSeats
      )
    }

    return this.get(
      `services/${serviceInfoId}/availabilities/${originStopId}/${exitString}?date-time=${moment(
        date
      ).format(
        'YYYYMMDDHHmm'
      )}${exitPrmSeatsString}&arrival-time=${specificDate}`, data
    )
  }

  public getAvailabilitiesEarlier = async (
    serviceInfoId: number,
    originStopId: number,
    destinationStopId: number,
    exitSeats: number,
    exitPrmSeats: number,
    date: Date,
    availabilityId: number,
    specificDate: boolean
  ): Promise<IServiceInfo[]> => {
    const exitString = repeatStringForService(
      '',
      destinationStopId,
      exitSeats + exitPrmSeats
    )

    let exitPrmSeatsString = ''
    if (exitPrmSeats > 0) {
      exitPrmSeatsString = repeatStringForService(
        '&prm-exit-stops=',
        destinationStopId,
        exitPrmSeats
      )
    }

    return this.get(
      `services/${serviceInfoId}/availabilities/${originStopId}/${exitString}?early=${availabilityId}&date-time=${moment(
        date
      ).format(
        'YYYYMMDDHHmm'
      )}${exitPrmSeatsString}&arrival-time=${specificDate}`
    )
  }

  public getAvailabilitiesLater = async (
    serviceInfoId: number,
    originStopId: number,
    destinationStopId: number,
    exitSeats: number,
    exitPrmSeats: number,
    date: Date,
    availabilityId: number,
    specificDate: boolean
  ): Promise<IServiceInfo[]> => {
    const exitString = repeatStringForService(
      '',
      destinationStopId,
      exitSeats + exitPrmSeats
    )

    let exitPrmSeatsString = ''
    if (exitPrmSeats > 0) {
      exitPrmSeatsString = repeatStringForService(
        '&prm-exit-stops=',
        destinationStopId,
        exitPrmSeats
      )
    }

    return this.get(
      `services/${serviceInfoId}/availabilities/${originStopId}/${exitString}?late=${availabilityId}&date-time=${moment(
        date
      ).format(
        'YYYYMMDDHHmm'
      )}${exitPrmSeatsString}&arrival-time=${specificDate}`
    )
  }
}

export default new ServicesInfoService()
